import React, { useEffect, useState } from "react";
import { delete_quotation_api, get_quotation_api } from "../Config/API";
import { calMaxPage, formatDateString } from "../Common/CommonFunction";
import { Edit, FileText, Trash2 } from "react-feather";
import { Tooltip } from "react-tooltip";
import { ToastContainer, toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { useNavigate } from "react-router-dom";

export const Quotation = () => {
  const [page, setPage] = useState(1);
  const [srNo, setSrNo] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const [dataList, setDataList] = useState({
    data: [],
    loading: true,
    totalRecords: "",
  });

  const navigate = useNavigate();
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchQuatationList(1, entriesPerPage);
    }, 1000); // Adjust the delay as needed (e.g., 500 milliseconds)

    return () => {
      clearTimeout(debounceTimeout); // Clear the timeout if searchTerm changes before the timeout expires
    };
  }, []);

  function fetchQuatationList(pg, epp) {
    setDataList({ ...dataList, loading: true, data: [] });

    const payload = {
      page: pg,
      limit: epp,
    };

    get_quotation_api(payload).then(
      (res) => {
        // console.log("res", res.data);
        setDataList({
          ...dataList,
          loading: false,
          data: res.data.data,
          totalRecords: res.data.total,
        });
        // console.log("calMaxPage(res.data.total)",calMaxPage(res.data.total))
        setMaxPage(calMaxPage(res.data.total));
        if (pg == 1) {
          setSrNo(0);
          setPage(1);
        }
      },
      (err) => {
        setDataList({
          ...dataList,
          loading: false,
          data: [],
          totalRecords: "",
        });
      }
    );
  }

  const del_quotation = (val) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record !",
      icon: "warning",
      confirmButtonColor: "rgb(38 171 131)",
      cancelButtonColor: "#807e7ed7",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        // Firing delete api
        const payload = {
          uuid: val.uuid,
        };
        delete_quotation_api(payload).then(
          (res) => {
            toast.success("Quotation deleted successfully !", {
              autoClose: 3000,
            });
            if (dataList.data.length == 1 && page > 1) {
              fetchQuatationList(page - 1, entriesPerPage);
              setSrNo(parseInt(srNo - entriesPerPage));
              setPage(page - 1);
            } else {
              fetchQuatationList(page, entriesPerPage);
            }
          },
          (err) => {
            if (err.response.status === 400) {
              toast.error(err.response.data.message, {
                autoClose: 2000,
              });
              // reset();
            } else {
              toast.error("Something went wrong ", {
                autoClose: 2000,
              });
            }
          }
        );
      }
    });
  };
  return (
    <div className="px-10 py-2 h-full overflow-y-auto pb-[10%] ">
      <ToastContainer />

      <h1 className="mb-3 text-4xl">Quotation </h1>
      <div className="h-full w-full">
        <div className="overflow-x-auto ">
          {dataList.loading ? (
            <div className="text-center ">
              <svg
                aria-hidden="true"
                className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : dataList.data.length > 0 ? (
            <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
              <thead className="bg-gray-200 font-bold">
                <tr>
                  <th className="border border-gray-300 px-4 py-2">Sr.No</th>
                  <th className="border border-gray-300 px-4 py-2">Quote Id</th>
                  <th className="border border-gray-300 px-4 py-2">Date</th>
                  <th className="border border-gray-300 px-4 py-2">Customer</th>
                  <th className="border border-gray-300 px-4 py-2">GST</th>
                  <th className="border border-gray-300 px-4 py-2">Status</th>

                  <th className="border border-gray-300 px-4 py-2 ">Action</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {dataList.data.map((item, i) => (
                  <tr key={item.uuid}>
                    <td className="border border-gray-300 px-4 py-2">
                      {i + Number(srNo) + 1}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.quotation_id}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {formatDateString(item.quotation_date, "-")}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.customer}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.gst_number}
                    </td>

                    <td className="border border-gray-300 px-4 py-2">
                      {item.status}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <div className="flex">
                        <>
                          <Tooltip id={"edit-tooltip" + i} place="top" />
                          <Edit
                            data-tooltip-id={"edit-tooltip" + i}
                            data-tooltip-content={"Edit Quoatation"}
                            className=" cursor-pointer m-2"
                            color="#807e7ed7"
                            size={20}
                            onClick={() => {
                              console.log("edit");
                              navigate("/edit-quotation", {
                                state: item,
                              });
                            }}
                          />
                        </>
                        <>
                          <Tooltip id={"delete-tooltip" + i} place="top" />

                          <Trash2
                            data-tooltip-id={"delete-tooltip" + i}
                            data-tooltip-content={"Delete Quoatation"}
                            className=" cursor-pointer m-2"
                            onClick={() => {
                              del_quotation(item);
                            }}
                            color="#807e7ed7"
                            size={20}
                          />
                        </>
                        <>
                          <Tooltip id={"pdf-tooltip" + i} place="top" />

                          <FileText
                            data-tooltip-id={"pdf-tooltip" + i}
                            data-tooltip-content={"Generate PDF"}
                            className=" cursor-pointer m-2"
                            onClick={() => {
                              console.log("pdf");
                              navigate("/quotation-pdf", {
                                state: item,
                              });
                            }}
                            color="#807e7ed7"
                            size={20}
                          />
                        </>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="w-full flex align-center">
              <div className="py-4 text-center">
                <h1 className="catLable mt-5 text-3xl font-semibold ">
                  {`No quotation records found !`}
                </h1>
              </div>
            </div>
          )}
        </div>
        {dataList.loading ? null : dataList.data?.length > 0 ? (
          <div className="mt-4 flex justify-between items-center ">
            <p>{`Showing ${parseInt(srNo) + 1} to ${
              dataList.data.length + entriesPerPage * page - entriesPerPage
            } of ${dataList.totalRecords} entries`}</p>
            <div className="flex justify-evenly w-1/4">
              <button
                className={
                  page == 1
                    ? `w-full secondary-color  p-2  text-white  cursor-pointer`
                    : `main-color  w-full  p-2  text-white  cursor-pointer`
                }
                disabled={page === 1 ? true : false}
                onClick={() => {
                  fetchQuatationList(
                    page - 1,
                    entriesPerPage,
                    parseInt(srNo) - parseInt(entriesPerPage)
                  );
                  setSrNo((prevC) =>
                    page - 1 == 1 ? 0 : prevC - parseInt(entriesPerPage)
                  );
                  setPage(page - 1);
                }}
              >
                {"Prev"}
              </button>

              <button
                className="w-full  p-2  text-black  cursor-pointer"
                disabled={true}
              >
                {" "}
                {page}{" "}
              </button>

              <button
                className={
                  page == maxPage
                    ? `w-full  secondary-color  p-2  text-white  cursor-pointer`
                    : `main-color  w-full  p-2  text-white  cursor-pointer`
                }
                disabled={page == maxPage ? true : false}
                onClick={() => {
                  fetchQuatationList(
                    page + 1,
                    entriesPerPage,
                    parseInt(srNo) + parseInt(entriesPerPage)
                  );
                  setSrNo((prevC) => prevC + parseInt(entriesPerPage));
                  setPage(page + 1);
                }}
              >
                {"Next"}
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
